import { useFeatureFlagEnabled } from "posthog-js/react";

const REACT_ENV = import.meta.env.VITE_REACT_ENV;

export function useCanAmendFromReportScreen() {
  const enabled = useFeatureFlagEnabled("canAmendFromReportScreen");

  return enabled || ["dev"].includes(REACT_ENV);
}
